/** A site as the bare domain its logo is looked up by (no scheme, no www); null when there is none. */
export function logoDomain(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;

  const candidate = /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const hostname = new URL(candidate).hostname.toLowerCase().replace(/^www\./, '');
    return hostname || null;
  } catch {
    const fallback = trimmed
      .split(/[/?#]/, 1)[0]
      ?.toLowerCase()
      .replace(/^www\./, '');
    return fallback || null;
  }
}

/** A company's logo from logo.dev, by its publishable token; null without a site or a token. */
export function logoDevUrl(
  domainOrUrl: string | null | undefined,
  token: string | null | undefined,
  /** missing404 asks for a 404 instead of logo.dev's lettered stand-in, so the caller can draw its own. */
  opts: { size?: number; missing404?: boolean } = {},
): string | null {
  const domain = logoDomain(domainOrUrl);
  if (!domain || !token) return null;
  const fallback = opts.missing404 ? '&fallback=404' : '';
  return `https://img.logo.dev/${encodeURIComponent(domain)}?token=${encodeURIComponent(token)}&size=${opts.size ?? 128}&format=png${fallback}`;
}
